module.exports = __webpack_public_path__ + "static/media/mollo-group.903963b9.png";